import {useState} from "react";
import FormContent from "./FormContent";
import Button from "./Button";
import dayjs from "dayjs";
import {nanoid} from "nanoid";
import {db} from "../firebase";
import {set, ref} from "firebase/database";

function Form() {
  const [note, setNote] = useState({title:"", text:""});
  const [valid, setValid] = useState(true);

  function resetForm() {
    setNote({title:"", text:""});
    setValid(true);
  }

  function createNote() {
    const date = new Date();

    const newNote = {
      id: nanoid(),
      title: note.title,
      text: note.text,
      date: dayjs(date).format('MMMM DD, HH:mm:ss A'),
      status: "active",
    };

    set(ref(db, newNote.id), newNote);

    resetForm();
  }

  function onClickHandler() {
    note.text ? createNote() : setValid(false);
  };

  return (
    <form className="form" action="">
      <FormContent
        note={note}
        setNote={setNote}
        valid={valid}
        setValid={setValid}
      />
      <Button onClickHandler={onClickHandler} text="Add note"/>
    </form>
  );
}

export default Form;